import { NoteType } from "../../../utils/constants";
import {
  areTimeslotsEqual,
  formatTimeslotLabel,
} from "../../../utils/dateUtils";

/**
 * History note for a booking made through the Scheduler.
 *
 * historyAutoGen cannot describe this change. ScheduleDateTimeInput writes a
 * Date into scheduledDateTime, and the generic scalar pass only notes values
 * that are a string, number, or boolean — so a first-time booking (initial
 * value null, new value a Date) produced no entry at all, and a reschedule
 * logged a raw `Date.toString()` against the record's UTC ISO string. Built
 * from the timeslots instead and formatted in the yard's wall clock, the same
 * way every other appointment label reads.
 *
 * @param {object} previousTimeslot - the booking on the record before the save
 * @param {object} nextTimeslot - the booking being saved
 * @returns {object|null} a history note to append, or null when the appointment
 *   is unchanged or has no time to describe
 */
export const buildAppointmentNote = (previousTimeslot, nextTimeslot) => {
  if (!nextTimeslot) return null;
  if (areTimeslotsEqual(previousTimeslot, nextTimeslot)) return null;

  const next = formatTimeslotLabel(nextTimeslot, nextTimeslot.eventType?.name);
  if (!next) return null;

  const previous = previousTimeslot
    ? formatTimeslotLabel(previousTimeslot, previousTimeslot.eventType?.name)
    : "";

  return {
    text: previous
      ? `Appointment changed from ${previous} to ${next}`
      : `Appointment set to ${next}`,
    type: NoteType.GENERIC,
    date: new Date(),
    by: window.appUser?.fullName,
  };
};
